module.exports = __webpack_public_path__ + "img/LV4.5a166cdc.webp";